import {isEmpty} from "lodash";

const FIXED_REMARK_HEIGHTS = new Set(["80px", "80", 80]);
const TALL_TEXTAREA_MIN_HEIGHTS = new Set(["100px", "100", 100, "80px", "80", 80, "60px", "60", 60]);
const TEXTAREA_AUTO_GROW_MAX_H = 100;

function applyRemarkMaxHeight(next) {
    if (!next.maxHeight) {
        next.maxHeight = `${TEXTAREA_AUTO_GROW_MAX_H}px`;
    }
    if (!next.overflowY) {
        next.overflowY = "auto";
    }
    return next;
}

function isBlankText(value) {
    if (value == null || value === "") return true;
    return typeof value === "string" && !value.trim();
}

/** 비고 등 — 내용 없을 때 height/minHeight 80px 고정 제거 */
export function resolveTextAreaDisplayStyle(style, data, value, {showInput = false} = {}) {
    const base = {...(style || {})};
    const empty = isBlankText(value) && isBlankText(data);

    if (!empty) {
        if (TALL_TEXTAREA_MIN_HEIGHTS.has(base.minHeight) || TALL_TEXTAREA_MIN_HEIGHTS.has(base.height)) {
            return applyRemarkMaxHeight({...base});
        }
        return base;
    }

    const next = {...base};

    if (TALL_TEXTAREA_MIN_HEIGHTS.has(next.minHeight) || TALL_TEXTAREA_MIN_HEIGHTS.has(next.height)) {
        return applyRemarkMaxHeight(next);
    }

    delete next.height;

    if (FIXED_REMARK_HEIGHTS.has(next.minHeight)) {
        delete next.minHeight;
    }

    if (showInput && !next.minHeight) {
        next.minHeight = "var(--detail-kv-textarea-min-h, 80px)";
    }

    return next;
}
